import { Anchor, Group, Loader } from "@mantine/core";
import { Link, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { ErrorAlert } from "../../platform/ErrorAlert";
import { PageColumns } from "../../ui/PageColumns";
import { GenerationDetail } from "../../platform/jobs/detail/GenerationDetail";
import { useJob } from "../../platform/jobs/detail/job-query";

/**
 * One job's page: the same detail card the studio opens as a modal (design-system.md 3.4), so a
 * link to a job (an email, the jobs list) has a page. The job stays current as `useJob` says.
 */
export function JobScreen() {
  const { teamId, jobId } = useParams({ from: "/signed-in/teams/$teamId/jobs/$jobId" });
  const job = useJob(teamId, jobId);
  const back = (
    <Anchor
      size="sm"
      mb="md"
      renderRoot={(props) => <Link {...props} to="/teams/$teamId/jobs" params={{ teamId }} />}
    >
      <Group gap={6} component="span">
        <ArrowLeft size={16} aria-hidden />
        All jobs
      </Group>
    </Anchor>
  );
  return (
    <PageColumns top={back}>
      {job.isPending ? <Loader size="sm" aria-label="Loading the job" /> : null}
      {job.isError ? <ErrorAlert error={job.error} /> : null}
      {job.isSuccess ? (
        <Group justify="center">
          <GenerationDetail
            teamId={teamId}
            job={job.data}
            readAgain={() => void job.refetch()}
            headingOrder={1}
          />
        </Group>
      ) : null}
    </PageColumns>
  );
}
